export const DEVICES_IMPORT_OPEN_MODAL = "DEVICES_IMPORT_OPEN_MODAL";
export const DEVICES_IMPORT_CLOSE_MODAL = "DEVICES_IMPORT_CLOSE_MODAL";

export const DEVICES_IMPORT_PROCESS_CSV = "DEVICES_IMPORT_PROCESS_CSV";
export const DEVICES_IMPORT_PROCESS_CSV_RESULT = "DEVICES_IMPORT_PROCESS_CSV_RESULT";

export const DEVICES_IMPORT_PROCESS_CALAMP_CSV = "DEVICES_IMPORT_PROCESS_CALAMP_CSV";
export const DEVICES_IMPORT_PROCESS_CALAMP_CSV_RESULT = "DEVICES_IMPORT_PROCESS_CALAMP_CSV_RESULT";

export const DEVICES_IMPORT_PROCESS_QUECLINK_CSV = "DEVICES_IMPORT_PROCESS_QUECLINK_CSV";
export const DEVICES_IMPORT_PROCESS_QUECLINK_CSV_RESULT = "DEVICES_IMPORT_PROCESS_QUECLINK_CSV_RESULT";

export const DEVICES_IMPORT_PROCESS_PUI_CSV = "DEVICES_IMPORT_PROCESS_PUI_CSV";
export const DEVICES_IMPORT_PROCESS_TELITEK_CSV = "DEVICES_IMPORT_PROCESS_TELITEK_CSV";

export const DEVICES_IMPORT_GET_DEVICE_MODEL = "DEVICES_IMPORT_GET_DEVICE_MODEL";
export const DEVICES_IMPORT_GET_DEVICE_MODEL_RESULT = "DEVICES_IMPORT_GET_DEVICE_MODEL_RESULT";

export const DEVICES_IMPORT_LOAD_PHONE_NUMBERS = "DEVICES_IMPORT_LOAD_PHONE_NUMBERS";
export const DEVICES_IMPORT_LOAD_PHONE_NUMBERS_RESULT = "DEVICES_IMPORT_LOAD_PHONE_NUMBERS_RESULT";

export const DEVICES_IMPORT_SAVE = "DEVICES_IMPORT_SAVE";
export const DEVICES_IMPORT_SAVE_RESULT = "DEVICES_IMPORT_SAVE_RESULT";

export const DEVICES_IMPORT_GET_CALAMP_DEVICES_INFO = "DEVICES_IMPORT_GET_CALAMP_DEVICES_INFO";
export const DEVICES_IMPORT_GET_CALAMP_DEVICES_INFO_RESULT = "DEVICES_IMPORT_GET_CALAMP_DEVICES_INFO_RESULT";

export const DEVICES_IMPORT_GET_GEOMETRIS_DEVICES_INFO = "DEVICES_IMPORT_GET_GEOMETRIS_DEVICES_INFO";
export const DEVICES_IMPORT_GET_GEOMETRIS_DEVICES_INFO_RESULT = "DEVICES_IMPORT_GET_GEOMETRIS_DEVICES_INFO_RESULT";
export const DEVICES_IMPORT_PROCESS_GEOMETRIS_CSV = "DEVICES_IMPORT_PROCESS_GEOMETRIS_CSV";
export const DEVICES_IMPORT_PROCESS_GEOMETRIS_CSV_RESULT = "DEVICES_IMPORT_PROCESS_GEOMETRIS_CSV_RESULT";

export const DEVICES_IMPORT_PROCESS_CEREBRUMX_CSV = "DEVICES_IMPORT_PROCESS_CEREBRUMX_CSV";
export const DEVICES_IMPORT_PROCESS_PACIFIC_TRACK_CSV = "DEVICES_IMPORT_PROCESS_PACIFIC_TRACK_CSV";
export const DEVICES_IMPORT_PROCESS_ZONAR_CSV = "DEVICES_IMPORT_PROCESS_ZONAR_CSV";
export const DEVICES_IMPORT_PROCESS_GENX_CSV = "DEVICES_IMPORT_PROCESS_GENX_CSV";

export const DEVICES_IMPORT_PROCESS_DIGITAL_MATTERS_CSV = "DEVICES_IMPORT_PROCESS_DIGITAL_MATTERS_CSV";
export const DEVICES_IMPORT_PROCESS_LIGHTMETRICS_CSV = "DEVICES_IMPORT_PROCESS_LIGHTMETRICS_CSV";
export const DEVICES_IMPORT_PROCESS_M2MD_CSV = "DEVICES_IMPORT_PROCESS_M2MD_CSV";
export const DEVICES_IMPORT_PROCESS_SMARTWITNESS_CSV = "DEVICES_IMPORT_PROCESS_SMARTWITNESS_CSV";

